import { NgModule } from '@angular/core';
import { AmdScrollService } from './scroll.service';
export class AmdScrollModule {
}
AmdScrollModule.decorators = [
    { type: NgModule, args: [{
                providers: [AmdScrollService]
            },] },
];
/**
 * @nocollapse
 */
AmdScrollModule.ctorParameters = () => [];
function AmdScrollModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdScrollModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdScrollModule.ctorParameters;
}
//# sourceMappingURL=scroll.module.js.map
//# sourceMappingURL=scroll.module.js.map
